module.exports = __webpack_public_path__ + "static/img/图层 24.7478548e.png";